/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getCachedUserToken } from '../../../utilities/caching';
import { gotoUrlEnvironment } from '../../../utilities/helpers';
import { ACCOUNT_REGIONS } from '../../../utilities/constants';
import { walletCurrenciesTypes } from '../constants';
import { WITHDRAWAL_DEEPLINK_QUERY_PARAMS, WITHDRAWAL_DEEPLINK_SESSION_KEYS } from './constants';
import { useLedgerFilteredWallets } from '../../../utilities/sharedHooks/ledgerWallets';
import { WALLETS_ALL } from '../queries';

const WithdrawalDeeplink = () => {
  const location = useLocation();
  const history = useHistory();

  const { data: allWallets } = useLedgerFilteredWallets(WALLETS_ALL);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currency = searchParams.get(WITHDRAWAL_DEEPLINK_QUERY_PARAMS.CURRENCY);
    const appId = searchParams.get(WITHDRAWAL_DEEPLINK_QUERY_PARAMS.APP_ID);

    const isRowApp = appId === process.env.REACT_APP_ROW_APP_NAME;
    const isUsApp = appId === process.env.REACT_APP_US_APP_NAME;
    const isValidAppId = isRowApp || isUsApp;
    const isOnRowHost = window.location.hostname === process.env.REACT_APP_FE_BASE_HOSTNAME;
    const isOnUsHost = window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME;

    // client always enters through the ROW base URL; hop to the US app unless
    // we're already on the app that matches the given app_id. Without a
    // recognized app_id there's nothing to match against, so stay on
    // whichever app is already open.
    if (isValidAppId && !(isRowApp && isOnRowHost) && !isOnUsHost) {
      gotoUrlEnvironment(ACCOUNT_REGIONS.US, `withdrawal${location.search}`);
      return;
    }

    // Remembered before the wallets are read: an expired token makes that
    // request answer 401, which resets the session and hard-redirects to
    // /timeout, so this is the only chance to record where to come back to.
    sessionStorage.setItem(
      WITHDRAWAL_DEEPLINK_SESSION_KEYS.RETURN_URL,
      `${location.pathname}${location.search}`
    );

    const token = getCachedUserToken();
    if (!token) {
      history.push('/onboarding/login');
      return;
    }

    if (!allWallets) return;

    const matchedWallet = currency
      ? allWallets.find((wallet) => wallet.coin?.toUpperCase() === currency.toUpperCase())
      : null;

    const isFiatWallet =
      matchedWallet && matchedWallet.wallet_type?.toLowerCase() === walletCurrenciesTypes.FIAT;

    const dashboardSearch = currency
      ? `?${WITHDRAWAL_DEEPLINK_QUERY_PARAMS.CURRENCY}=${encodeURIComponent(currency)}`
      : '';
    // the deeplink made it through, so it shouldn't be replayed on a later login
    sessionStorage.removeItem(WITHDRAWAL_DEEPLINK_SESSION_KEYS.RETURN_URL);
    history.push(
      `/dashboard/accounts/${
        isFiatWallet ? walletCurrenciesTypes.FIAT : walletCurrenciesTypes.CRYPTO
      }${dashboardSearch}`
    );
  }, [allWallets]);

  return null;
};

export default WithdrawalDeeplink;
